import {
    Autocomplete,
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    TextField,
    Typography
} from '@mui/material';
import React, { useState } from 'react';
import { SalesPartnerBankAccountsServices } from 'src/services/salesPartner/SalesPartnerBankAccountsServices';
import { useCustomerData } from 'src/content/pages/customer/customerData';
import { enqueueSnackbar } from 'notistack';
import { StatusSwitch } from 'src/components/VemigoGrid/VemigoStarusFeild';
import {
    customerStyle,
    useStyles
} from 'src/theme/vemigoCustomStyles/VemigoCustomStyles';
import VemigoTextFeild from 'src/components/VemigoGrid/VemigoTextFeild';
import { useSalesPartnerData } from '../../SalesPartnerData';

interface EditProps {
    handleClose: () => void;
}

const EditSalesPartnerBankAccount: React.FC<EditProps> = ({ handleClose }) => {
    const { bankAccountTypes } = useCustomerData();
    const { bankAccounts, setBankAccountsList, bankAccountsList } = useSalesPartnerData();

    const [editData, setEditData] = useState(bankAccounts);
    const handleDataChange = (fieldName: string, value: any) => {
        setEditData({ ...editData, [fieldName]: value });
    };

    const handleUpdate = async () => {
        try {
            const res = await SalesPartnerBankAccountsServices.updateData(editData);
            enqueueSnackbar(`Bank account '${editData.accountName}' updated successfully`, { variant: 'success' });

            const updatedList = bankAccountsList.map((item) =>
                item.id === res.id ? res : item
            );
            setBankAccountsList(updatedList);

            handleClose();
        } catch (error) {
            console.error(error);
            enqueueSnackbar(`Bank account '${editData.accountName}' not updated`, { variant: 'error' });
        }
    };

    const fields = [
        { id: 'accountName', title: 'Account Name', type: 'text', size: 6 },
        { id: 'accountNumber', title: 'Account Number', type: 'text', size: 6 },
        { id: 'bankName', title: 'Bank Name', type: 'text', size: 6 },
        { id: 'ifscCode', title: 'IFSC Code', type: 'text', size: 6 },
        { id: 'micrCode', title: 'MICR Code', type: 'text', size: 6 },
        {
            id: 'accountTypeId',
            title: 'Account Type',
            selectedId: editData.accountTypeId,
            name: bankAccountTypes?.find((x) => x.id === editData.accountTypeId)?.name,
            type: 'select',
            size: 6,
            dataList: bankAccountTypes
        },

    ];

    return (
        <>
            <DialogTitle style={customerStyle.recentSearchStyle}>Edit Bank Account</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    {fields.map((field) => (
                        <Grid item xs={field.size} key={field.id}>
                            <Typography variant="h5" style={useStyles.formTitle}>
                                {field.title}
                            </Typography>
                            {field.type === 'select' ? (
                                <Autocomplete
                                    options={field.dataList}
                                    getOptionLabel={(option) => option.name}
                                    style={useStyles.formControl}
                                    fullWidth
                                    value={bankAccountTypes.find(
                                        (data) => data.id === field.selectedId
                                    )}
                                    onChange={(event, newValue) => {
                                        const dataID = newValue ? newValue.id : null;
                                        handleDataChange(field.id, dataID);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder={field.title}
                                            variant="outlined"
                                        />
                                    )}
                                />
                            ) : (
                                <VemigoTextFeild
                                    style={useStyles.formControl}
                                    id={field.id}
                                    type={field.type}
                                    fullWidth
                                    counter={false}
                                    readonly={false}
                                    value={editData[field.id] || ''}
                                    onChange={(e) => handleDataChange(field.id, e.target.value)}
                                />
                            )}
                        </Grid>
                    ))}
                    <StatusSwitch
                        newData={editData}
                        handleSwitchChange={handleDataChange}
                        field={'isActive'}
                    />
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">Cancel</Button>
                <Button onClick={handleUpdate} variant="contained" color="primary">Update</Button>
            </DialogActions>
        </>
    );
};

export default EditSalesPartnerBankAccount;